import * as React from "react";
import * as cn from "classnames";

const styles = require("./DialogActions.less");

export interface DialogActionsProps {
    actions?: React.ReactNode;
    additionalActions?: React.ReactNode;
    className?: string;
}

export const DialogActions: React.SFC<DialogActionsProps> = ({className, actions, additionalActions}) => {
    return <div className={cn(styles.actions, className)}>
        <div className={styles.additionalActions}>
            {additionalActions}
        </div>
        <div className={styles.primaryActions}>
           {actions}
        </div>
   </div>;
};

export default DialogActions;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--1!./app/components/DialogLayout/Custom/DialogActions.tsx